import { DatabaseId } from "../helpers/Id";
import { Asset } from "../responses/TransactionEvent";

// account type enum
export enum AccountType {
  Individual = "Individual",
  Trust = "Trust",
  Company = "Company",
  SMSF = "SMSF",
}

// account sub type enum
export enum AccountSubType {
  Investor = "Investor",
  Trader = "Trader",
}

export const ActivityTypeName: Record<AccountSubType, string> = {
  [AccountSubType.Investor]: "Investment",
  [AccountSubType.Trader]: "Trading",
};

export const AccountTypeCGTDiscount: Record<AccountType, boolean> = {
  Company: false,
  Individual: true,
  SMSF: true,
  Trust: true,
};

export enum ParcelMethodType {
  FIFO = "FIFO",
  LIFO = "LIFO",
  HIFO = "HIFO",
  LTFO = "LTFO",
}

export type ParcelMethod = {
  startYear: string;
  endYear: string;
  method: ParcelMethodType;
};

export type Address = {
  street: string;
  suite: string;
  suburb: string;
  state: string;
  postcode: string;
};

export type PhoneNumber = {
  countryCode: string;
  number: string;
};

export type TaxSettingsData = {
  homeCountry: string;
  taxYear: string;
  gstRegistered: boolean;
  parcelMethods: ParcelMethod[];
  timeZone: string;
  defaultParcelMethod?: ParcelMethodType;
};

export type TaxSettingsWithBaseCurrency = TaxSettingsData & {
  _id: DatabaseId;
  baseCurrency: Asset;
};
